import React, { useMemo, useState, useEffect } from "react";
import "../blog.css";

export function PostContentText({ content, className }) {
  const [textContent, setTextContent] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!content || content.ops.length === 0) {
      setTextContent("");
      setIsLoading(false);
      return;
    }

    // Lazy load Quill only when needed
    import("./QuillTextExtractor").then(({ extractTextFromQuill }) => {
      const extractedText = extractTextFromQuill(content);
      setTextContent(extractedText);
      setIsLoading(false);
    });
  }, [content]);

  if (isLoading) {
    return <div className={className}>Carregando conteúdo...</div>;
  }

  return (
    <div className={className ? className : "blog-text-preview"}>
      {textContent}
    </div>
  );
}
